var React = require('react');

function ExtraMid (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Frame 1143768"},[React.createElement("path",{"id":"Vector 303","d":"M10.3333 28C10.3333 29.4728 11.5272 30.6667 13 30.6667C14.4728 30.6667 15.6667 29.4728 15.6667 28C15.6667 26.5272 14.4728 25.3333 13 25.3333C11.5272 25.3333 10.3333 26.5272 10.3333 28ZM0.5 0V24H1.5V0H0.5ZM5 28.5H13V27.5H5V28.5ZM0.5 24C0.5 26.4853 2.51472 28.5 5 28.5V27.5C3.067 27.5 1.5 25.933 1.5 24H0.5Z","fill":"currentColor","key":0}),React.createElement("path",{"id":"Vector 304","d":"M1 0V56","stroke":"currentColor","key":1})]));
}

ExtraMid.defaultProps = {"width":"16","height":"56","viewBox":"0 0 16 56","fill":"none"};

module.exports = ExtraMid;

ExtraMid.default = ExtraMid;
